
import React, { useEffect, useState } from 'react';

import ButtonCommandTool from './ButtonCommandTool';

const ButtonCommandTools = (props) => {

    const [selectedToolId, setSelectedToolId] = useState('');

    useEffect(() => {
        const existsSelectedTool = props.tools.filter(item => {
            return (item.toolId === selectedToolId);
        }).length > 0;

        if (!existsSelectedTool) {
            if (props.tools.length > 0) {
                selectTool(props.tools[0].toolId);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.tools]);

    const getIconSrc = (item) => {
        return item.iconMultiSceneCore
            ? MultiSceneCore.PointCloudScene.Icons[item.iconMultiSceneCore]
            : item.iconSrc;
    }

    const getToolById = (toolId) => {
        return props.tools.reduce((previous, current) => {
            return (current.toolId === toolId)
                ? current
                : previous;
        }, null);
    }

    const handleClick = (toolId) => {
        selectTool(toolId);
    }

    const selectTool = (toolId) => {
        setSelectedToolId(toolId);
        if (props.onSelectTool) {
            props.onSelectTool(toolId, getToolById(toolId));
        }
    }

    return props.tools.map(item => {
        return <ButtonCommandTool
            key={item.toolId}
            toolId={item.toolId}
            iconName={item.iconName}
            iconSrc={getIconSrc(item)}
            title={item.title}
            selected={selectedToolId === item.toolId}
            onClick={handleClick}
        />
    });
}

export default ButtonCommandTools;
